import React from "react";

const QUICK_IDS = ["services", "fleet", "destinations", "booking", "contact"];

const FooterQuickLinks = ({ heading, labels, onNavigate }) => (
  <div className="md:col-span-3">
    <p className="text-xs uppercase tracking-[0.25em] text-[#C6A87C] mb-5">{heading}</p>
    <ul className="space-y-3">
      {QUICK_IDS.map((id) => (
        <li key={id}>
          <button
            data-testid={`footer-link-${id}`}
            onClick={() => onNavigate(id)}
            className="text-sm text-[#E2E8F0] hover:text-[#C6A87C] transition-colors capitalize"
          >
            {labels[id] || id}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default FooterQuickLinks;
